import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateMovimientoRequest } from '@models/movimiento/createMovimientoRequest.mode';
import { MovimientoDetailDto } from '@models/movimiento/movimientoDetailDto.model';
import { UpdateMovimientoRequest } from '@models/movimiento/updateMovimientoRequestUpdate.mode';
import { isFalsy } from 'utility-types';
import { ComprobanteVinculadoDto } from '@models/base/comprobanteVinculadoDto.model';

type NewType = Observable<any>;

@Injectable({
  providedIn: 'root'
})
export class MovimientosService {

  private id!: number;

  set setId(id: number) {
    this.id = id;
  }

  get getId() {
    return this.id;
  }

  constructor(private http: HttpClient) { }

  create(createMovimientoRequest: CreateMovimientoRequest): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>("/api/Movimiento/Create", createMovimientoRequest);
  }

  createMovimientosConBonificacion(createMovimientoRequest: CreateMovimientoRequest, soloInquilino: boolean = false): Observable<MovimientoDetailDto[]> {
    return this.http.post<MovimientoDetailDto[]>(`/api/Movimiento/CreateMovimientosConBonificacion?soloInquilino=${soloInquilino}`, createMovimientoRequest);
  }

  createCollection(createCollectionMovimientoRequest: CreateMovimientoRequest[]): Observable<number[]> {
    return this.http.post<number[]>("/api/Movimiento/CreateCollection", createCollectionMovimientoRequest);
  }

  /** Comprobantes vinculados a un movimiento (trazabilidad del detalle) */
  getComprobantesVinculados(idMovimiento: number): Observable<ComprobanteVinculadoDto[]> {
    return this.http.get<ComprobanteVinculadoDto[]>(
      "/api/Movimiento/GetComprobantesVinculados?idMovimiento=" + idMovimiento);
  }

  update(updateMovimientoRequest: UpdateMovimientoRequest): Observable<any> {
    return this.http.put<any>("/api/Movimiento/Update", updateMovimientoRequest);
  }

  getAll(): Observable<MovimientoDetailDto[]> {
    return this.http.get<MovimientoDetailDto[]>("/api/Movimiento/GetAll");
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/Movimiento/Delete?id=" + id);
    else
      return of(null)
  }

  /**
   * Elimina el movimiento junto con los que se crearon colgando de él.
   *
   * Sólo se usa en la pantalla de bonificaciones del recibo: al crear una
   * bonificación se generan varios movimientos encadenados y el delete común
   * falla por referencias. No usar desde otras pantallas.
   */
  deleteConVinculados(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/Movimiento/DeleteConVinculados?id=" + id);
    else
      return of(null)
  }

  getAllByFilter(fechaEmsionDesde: string, fechaEmisionHasta: string, numeroContrato: number | null, idTipoMovimiento: number | null, idInquilino: number | null, idContrato: number | null, idPropiedad: number | null, idPropietario: number | null, idPeriodoContrato: number | null, fechaPagoDesde: string | null, fechaPagoHasta: string | null,): Observable<MovimientoDetailDto[]> {

    let filtro = ""

    if (fechaEmsionDesde != null && fechaEmisionHasta != null && fechaEmsionDesde != "" && fechaEmisionHasta != "")
      filtro += "?fechaEmisionDesde=" + fechaEmsionDesde + "&fechaEmisionHasta=" + fechaEmisionHasta

    if (numeroContrato != null && numeroContrato != 0)
      filtro += "&numeroContrato=" + numeroContrato

    if (idTipoMovimiento != null && idTipoMovimiento != 0)
      filtro += "&idTipoMovimiento=" + idTipoMovimiento

    if (idInquilino != 0 && idInquilino != null)
      filtro += "&idInquilino=" + idInquilino

    if (idContrato != 0 && idContrato != null)
      filtro += "&idContrato=" + idContrato

    if (idPropiedad != 0 && idPropiedad != null)
      filtro += "&idPropiedad=" + idPropiedad

    if (idPropietario != 0 && idPropietario != null)
      filtro += "&idPropietario=" + idPropietario

    if (idPeriodoContrato != 0 && idPeriodoContrato != null)
      filtro += "&idPeriodoContrato=" + idPeriodoContrato

    if (fechaPagoDesde != null && fechaPagoHasta != null && fechaPagoDesde != "" && fechaPagoHasta != "")
      filtro += "&fechaPagoDesde=" + fechaPagoDesde + "&fechaPagoHasta=" + fechaPagoHasta


    return this.http.get<MovimientoDetailDto[]>("/api/Movimiento/GetAllByFilter" + filtro);
  }

  getById(id: number): Observable<MovimientoDetailDto> {
    return this.http.get<MovimientoDetailDto>("/api/Movimiento/GetById?id=" + id);
  }
}
